import { useMemo } from "react";
import { MessageCircle, AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { formatAnswer, detectCitations } from "../lib/format";

const AREA_LABELS = {
  civil: "Direito Civil",
  trabalhista: "Direito Trabalhista",
  previdenciario: "Direito Previdenciário",
  consumidor: "Direito do Consumidor",
  geral: "Geral",
};

export default function AnswerCard({ item, whatsappLink }) {
  const tags = useMemo(() => detectCitations(item.answer), [item.answer]);
  const html = useMemo(() => ({ __html: formatAnswer(item.answer) }), [item.answer]);

  return (
    <article
      className="bg-white border border-border rounded-xl overflow-hidden animate-fade-up"
      data-testid={`answer-card-${item.id}`}
    >
      <div className="px-6 md:px-8 pt-6 pb-4 border-b border-border bg-muted/40">
        <div className="flex items-center justify-between gap-3 mb-2">
          <Badge className="bg-primary text-primary-foreground hover:bg-primary rounded-sm tracking-wider text-[10px] uppercase">
            {AREA_LABELS[item.area] || "Consulta"}
          </Badge>
          <span className="text-xs text-muted-foreground">
            {new Date(item.created_at).toLocaleString("pt-BR")}
          </span>
        </div>
        <p className="font-serif text-xl md:text-2xl text-primary leading-snug">
          {item.question}
        </p>
      </div>

      <div className="px-6 md:px-8 py-7 border-l-4 border-accent bg-white">
        {tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4" data-testid={`citations-${item.id}`}>
            {tags.map((t) => (
              <span
                key={t}
                className="bg-primary text-primary-foreground text-[10px] font-bold px-2 py-1 rounded-sm tracking-wider"
              >
                {t}
              </span>
            ))}
          </div>
        )}
        <div className="legal-prose" dangerouslySetInnerHTML={html} />

        <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pt-5 border-t border-border">
          <p className="text-xs italic text-muted-foreground inline-flex items-start gap-2">
            <AlertTriangle className="h-3.5 w-3.5 mt-[2px] flex-shrink-0" />
            Esta resposta tem caráter informativo. Para o seu caso concreto, fale com um advogado.
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noreferrer"
            data-testid={`answer-whatsapp-${item.id}`}
          >
            <Button className="bg-[#25D366] hover:bg-[#1faa55] text-white rounded-full h-10">
              <MessageCircle className="mr-2 h-4 w-4" />
              Falar com Dr. Edson
            </Button>
          </a>
        </div>
      </div>
    </article>
  );
}
